export default "__VITE_ASSET__346269f7__"